<template>
  <div class="link-views white-bg">
    <Table :columns="columns" :data="resultsObj.Result" :loading="loading">
      <template slot-scope="{ row}" slot="action">
        <div class="action-table">
          <span class="error" v-if="row.State==0">预约已取消</span>
          <a v-if="row.State==1" @click="Cancel(row)">取消预约</a>
          <span class="theme" v-if="row.State==2">(同意预约)</span>
          <span class="error" v-if="row.State==3">{{row.ErrReason}}</span>
        </div>
      </template>
    </Table>
    <Modal
      v-model="showfullscreen"
      fullscreen
      title="预约详情"
      :class="{'myfullscreen':true,'noLeft':isCollapsed }"
      :mask-closable="false"
    >
      <ul style="line-height:2.6; margin-left:50px;">
        <li>
          <strong>申请编号：</strong>
          <span>{{AppointmentDetails.AppointmentNo}}</span>
        </li>
        <li>
          <strong>申请人：</strong>
          <span>{{AppointmentDetails.UserName}}</span>
        </li>
        <li>
          <strong>联系方式：</strong>
          <span>{{AppointmentDetails.Telephone}}</span>
        </li>
        <li>
          <strong>申请实验室：</strong>
          <span>{{AppointmentDetails.RoomName}}</span>
        </li>
        <li>
          <strong>申请设备：</strong>
          <span>{{AppointmentDetails.Equipment}}</span>
        </li>
        <li>
          <strong>申请时间：</strong>
          <span>{{AppointmentDetails.TimeStart}}</span>
          &nbsp;&nbsp;
          <span>{{AppointmentDetails.TimeEnd}}</span>
        </li>
        <li>
          <strong>创建时间：</strong>
          <span>{{AppointmentDetails.CreateTime}}</span>
        </li>
        <li>
          <strong>申请原因：</strong>
          <span>{{AppointmentDetails.Describes}}</span>
        </li>
        <li>
          <strong>申请结果：</strong>
          <span v-if="AppointmentDetails.State==3" class="red">申请失败</span>
          <span v-else class="green">申请成功</span>
        </li>
        <li v-if="AppointmentDetails.State==3" class="red">
          <strong>失败原因：</strong>
          <span>{{AppointmentDetails.ErrReason}}</span>
        </li>
        <li v-else>
          <div style="text-align:center; display:inline-block;margin-left:50px;margin-top:50px;">
            <img src="../../../assets/imgs/code.png" alt>
            <div class="red">请用绑定此账号的微信账号扫描二维码获取开门密钥</div>
          </div>
        </li>
      </ul>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import * as homeApi from "../../../api/teacher-api.js";
import * as publicApi from "../../../api/public-api.js";
export default {
  name: "onlineResults",
  data() {
    return {
      loading: true,
      resultsObj: {},
      pageData: {
        page: 1,
        size: 10
      },
      showfullscreen: false,
      AppointmentDetails: {},
      columns: [
        {
          title: "申请编号",
          key: "AppointmentNo",
          align: "center"
        },
        {
          title: "申请人",
          key: "UserName",
          align: "center"
        },
        {
          title: "联系方式",
          key: "Telephone",
          align: "center"
        },
        {
          title: "申请实验室",
          key: "RoomName",
          align: "center"
        },
        {
          title: "申请日期",
          key: "TimeStart",
          align: "center"
        },
        {
          title: "申请时间段",
          key: "TimeEnd",
          align: "center"
        },
        {
          title: "备注",
          slot: "action",
          align: "center"
        }
      ]
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    }
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    //获取分页数据
    async getDataList() {
      this.resultsObj = await publicApi.GetAppointmentByIdList({
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 10
      });

      this.loading = false;
    },
    // 显示详情
    showDetail(row) {
      publicApi
        .GetAppointmentById({
          AppointmentId: row.AppointmentId
        })
        .then(res => {
          this.AppointmentDetails = res;
          this.showfullscreen = true;
        });
    },
    //取消预约
    Cancel(row) {
      this.$Modal.confirm({
        title: "取消预约",
        onOk: () => {
          publicApi.GetCancelById({ AppointmentId: row.AppointmentId }).then(
            res => {
              this.$Message.success({
                content: res.msg,
                duration: 3
              });
              this.getDataList();
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
</style>